export default {
  name: 'ticket',
  translationKey: 'ticket-module',
  routePrefix: 't',
  routeNamePrefix: 'ticket',
}
